import React from 'react';
import "./Our_Services.css";
import Breadcrumb_comp from '../../common/breadcrumb-comp/Breadcrumb_comp';
import Common_title from '../../common/common-title/Common_title';
import Our_Services_card from './Our_Services_card/Our_Services_card';

function Our_Services() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "SERVICES", link: "", isActive: true },
    ];

    const services = [
        {
            imgSrc: "/assets/images/services/services_card_img/img1.png",
            iconSrc: "/assets/images/services/services_card_icons/icon1.png",
            heading: "Construction & Civil Work",
            description: "From full-site construction to floor additions, our verified contractors handle everything from planning to execution for residential, office, or commercial projects."
        },
        {
            imgSrc: "/assets/images/services/services_card_img/img2.png",
            iconSrc: "/assets/images/services/services_card_icons/icon2.png",
            heading: "Plumbing Services",
            description: "Leak repairs, new installations, bathroom fittings, and water tank connections — connect with skilled plumbers for quick and reliable service."
        },
        {
            imgSrc: "/assets/images/services/services_card_img/img3.png",
            iconSrc: "/assets/images/services/services_card_icons/icon3.png",
            heading: "Electrical Services",
            description: "Wiring, switchboard repair, and electrical fixture installation done right. Hire certified electricians for safe and efficient work."
        },
        {
            imgSrc: "/assets/images/services/services_card_img/img4.png",
            iconSrc: "/assets/images/services/services_card_icons/icon4.png",
            heading: "POP & Interior Design",
            description: "Upgrade your space with stylish POP ceilings, wall designs, and decorative finishes. Connect with professional designers for creative interiors."
        },
        {
            imgSrc: "/assets/images/services/services_card_img/img5.png",
            iconSrc: "/assets/images/services/services_card_icons/icon5.png",
            heading: "Building Materials & Hardware Supply",
            description: "Order quality construction materials like cement, steel, bricks, and fittings from local vendors with doorstep delivery options."
        },
        {
            imgSrc: "/assets/images/services/services_card_img/img6.png",
            iconSrc: "/assets/images/services/services_card_icons/icon6.png",
            heading: "Tiles, Granite & Marble",
            description: "Shop premium tiles, granite, and marble from verified vendors for flooring, kitchens, and interiors."
        }
    ];

    return (
        <section className='Our_Services margin_section'>
            <div className="container">
                <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                <Common_title
                    title={"URBAN BUILD"}
                    subtitle={"Our Services"}
                />
                <div className="text_holder">
                    <p>
                        UrbanBuild connects you with reliable vendors and service professionals across a wide range of construction and maintenance categories. Whether it's a small repair or a large build, we have the right people for the job.
                    </p>
                </div>

                <div className="row justify-content-center">
                    {services.map((service, index) => (
                        <div className="col-xl-3 col-md-4 col-sm-6 col-8 mb-5  mx-md-2 mx-0" key={index}>
                            <Our_Services_card
                                imgSrc={service.imgSrc}
                                iconSrc={service.iconSrc}
                                heading={service.heading}
                                description={service.description}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Our_Services;
